import type { Messages } from './en';

export const es: Messages = {
  nav: {
    soon: 'Próximamente',
  },
  hero: {
    eyebrow: 'Para corredores que viajan',
    headlineLine1: 'Tú céntrate en la carrera.',
    headlineLine2: 'Del plan nos encargamos nosotros.',
    lead: 'La carrera dura tres horas. El fin de semana que la rodea — los hoteles, los traslados, la comida, el vuelo de vuelta — son tres semanas de pestañas abiertas. La parte difícil ya la hiciste; del resto nos ocupamos nosotros.',
    ctaNote: 'Gratis · sin tarjeta',
  },
  mock: {
    from: 'Desde',
    sortCost: 'Coste total',
    sortDate: 'Fecha',
    bestValue: 'Mejor relación',
    allIn: 'todo incluido',
  },
  problem: {
    eyebrow: 'El fin de semana, no la carrera',
    heading: 'La carrera nunca está donde dice el nombre.',
    body1:
      'Primero calculas si siquiera puedes permitírtela — la inscripción es lo de menos; son los vuelos, los hoteles y todo lo demás lo que decide si el viaje se hace o no. Pongamos que sí.',
    body2:
      'Y resulta que el recinto está a una hora de la ciudad. Así que es un hotel cerca de la salida, otro de vuelta en el centro para recuperarte, trenes que nunca has cogido, cenas que buscar dos veces y un vuelo de vuelta que tienes que calcular hacia atrás. Nada de eso es la carrera — y todo cae sobre ti.',
    realCost: '¿Coste real?',
    returnLeg: 'Vuelta',
    crewMessage: '«¿dónde nos alojamos??»',
    yourWeekend: 'Tu fin de semana',
    sorted: 'Resuelto',
    flights: 'Vuelos',
    stay: 'Alojamiento · 2 noches',
    race: 'Carrera · Beast',
    allIn: 'Total',
  },
  discovery: {
    eyebrow: 'Qué hace',
    heading: 'Calculamos el viaje entero, antes de que te comprometas.',
    lead: 'Dinos desde dónde sales. RaceAtlas clasifica cada carrera por lo que de verdad te va a costar — de puerta a puerta — inscripción, vuelos o coche, y un sitio donde dormir. Rangos honestos, una valoración de confianza en cada cifra y la carrera más barata que merece la pena, arriba del todo.',
    feat1Kicker: 'Cifras honestas',
    feat1Heading: 'Una valoración de confianza en cada coste',
    feat1Body:
      'Inscripción, viaje, alojamiento — cada línea indica cuántos datos reales la respaldan. Sin falsa precisión, nunca.',
    feat2Kicker: 'Desde tu puerta',
    feat2Heading: 'Coche o avión, decidido por ti',
    feat2Body:
      'Calculamos si te conviene ir en coche o en avión desde casa — y ordenamos el coste total en consecuencia.',
    feat3Kicker: 'Lo que merece la pena, primero',
    feat3Heading: 'Clasificadas, no solo listadas',
    feat3Body:
      'La carrera más barata que de verdad querrías está arriba. Reordena por fecha o distancia con un toque.',
  },
  twoJobs: {
    eyebrow: 'Gratis vs de pago',
    heading: 'Gratis te dice cuánto cuesta. Por 9,99 € te dice qué hacer.',
    freeTag: 'Gratis · una herramienta',
    freeHeading: 'Saber cuánto cuesta',
    freeBody:
      'Busca, clasifica y compara cada carrera por su coste total real desde casa. Guarda tu lista. Ilimitado, para siempre.',
    paidTag: '9,99 € · un servicio',
    paidHeading: 'Saber qué hacer',
    paidBody:
      'Un plan para el fin de semana que decide por ti — horarios de la mañana de carrera, parking y guardarropa, y el café y la cena ya elegidos, en tu ruta y según tu dieta.',
  },
  payoff: {
    eyebrow: 'El itinerario de 9,99 €',
    heading: 'Como un amigo que ya ha corrido la prueba.',
    body1:
      'Un amigo no te da una lista de ocho cafeterías — te dice adónde ir. Nosotros igual: el café de camino a la salida, la cena de después que encaja con tu dieta, el minuto exacto para salir y no perderte el guardarropa. Ya elegido, con el motivo a la vista. Cambia lo que quieras con un toque.',
    body2:
      'Conoce el recorrido, las horas de salida, el parking, el trayecto. Lo que solo aprenderías por las malas — la segunda vez.',
    cardDay: 'Sáb 23 ago · día de carrera',
    leaveHotel: 'Salir del hotel',
    leaveHotelSub: '15 min · el parking abre a las 07:00',
    coffee: 'Café · Bar Nuovo',
    coffeeSub: 'en tu ruta · +6 min · abre a las 06:30',
    raceStart: 'Salida · Beast',
    postRace: 'Comida tras la carrera · Sa Tanca',
    postRaceSub: 'vegetariano · +3 min en el camino de vuelta',
  },
  who: {
    eyebrow: 'Para quién es',
    heading: 'Hecho para corredores que viajan para competir.',
    lead: 'Atletas de resistencia que compiten en 5 a 15 pruebas al año — Spartan más Hyrox más una etapa de UTMB más un Tough Mudder es un calendario normal. Si corres una vez al año, con el plan gratuito te sobra. Si planeas varios fines de semana en el extranjero y quieres que se sienta menos como trabajo — eso somos nosotros.',
  },
  pricing: {
    eyebrow: 'Precios',
    heading: 'Gratis para decidir. Paga por la parte que no encuentras en ningún otro sitio.',
    freeTier: 'Gratis',
    freeAmount: '0 €',
    freeCadence: 'para siempre',
    freeDesc: 'Clasifica cada carrera por su coste real, desde tu puerta. Guarda una lista.',
    freeItem1: 'Búsqueda y clasificación de costes ilimitadas',
    freeItem2: 'Hasta 3 planes guardados',
    freeItem3: 'Calendario + recordatorios',
    perTripTier: 'Por viaje',
    perTripBadge: 'El producto',
    perTripAmount: '9,99 €',
    perTripCadence: 'pago único por carrera',
    perTripDesc:
      'El fin de semana de carrera, planificado y decidido — como un amigo que ya lo ha hecho.',
    perTripItem1: 'Cronograma de la mañana de carrera + parking',
    perTripItem2: 'Café, comidas y recuperación, ya elegidos',
    perTripItem3: 'Compartible · reembolsable durante 7 días',
    seasonTier: 'Pase de temporada',
    seasonBadge: 'Pronto',
    seasonAmount: '45 €',
    seasonCadence: 'al año',
    seasonDesc: 'Para 8+ carreras al año. Toda tu temporada, ilimitada, en un solo sitio.',
    seasonItem1: 'Todos los itinerarios incluidos',
    seasonItem2: 'Gasto de temporada, presupuesto y solapamientos',
    seasonItem3: 'Momento de reserva (tras el lanzamiento)',
  },
  final: {
    heading: 'Tú céntrate en la carrera.',
    lead: 'Del resto nos encargamos nosotros — lo que cuesta, dónde te alojas, cómo llegas y qué hacer al aterrizar. Gratis para empezar, sin tarjeta.',
  },
  footer: {
    privacy: 'Privacidad',
    terms: 'Términos',
    contact: 'Contacto',
  },
  seo: {
    title: 'Race Atlas — Tú céntrate en la carrera, del plan nos encargamos nosotros',
    description:
      'Race Atlas planifica tus fines de semana de carrera de principio a fin — lo que cuestan de verdad, dónde alojarte, cómo llegar y qué hacer al aterrizar. Tú céntrate en la carrera; del plan nos encargamos nosotros.',
  },
};
